/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const baseRecommendationItemRequestSchema = z
	.object({
		id: z.uuid().nullish(),
		external_id: z.uuid().nullish(),
		order: z.int().optional().default(0),
	})
	.describe("Базовый сериализатор для элемента рекомендации (целевой продукт).");
